// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"product-grid_productGrid__jsUN_","emptyList":"product-grid_emptyList__qGeS_","title":"product-grid_title__fvTYL","pagination":"product-grid_pagination__Cx4Mb"};